<template>
  <div class="container print-evolution">
    <b-overlay :show="loading" opacity="0.99">
      <ErrorsMessages :errors="errors" />
      <div v-show="errors.length == 0">
        <table class="report-container">
          <thead class="report-header">
            <tr>
              <th>
                <div></div>
              </th>
            </tr>
          </thead>
          <tbody class="report-content">
            <tr>
              <td>
                <div>
                  <table class="table">
                    <tr>
                      <td>
                        <div class="d-flex align-items-center">
                          <img
                            v-if="rest_home_logo_url"
                            class="rest_home_logo_url"
                            :src="rest_home_logo_url"
                          />
                          <div v-if="!rest_home_logo_url" class="ml-1">
                            <strong class="text-uppercase">{{
                              rest_home_name
                            }}</strong>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <img
                            v-if="evolution.resident_photo_url"
                            class="resident_photo_url"
                            :src="evolution.resident_photo_url"
                          />
                          <img
                            v-if="!evolution.resident_photo_url"
                            class="resident_photo_url"
                            :src="require('../../../assets/user.png')"
                          />
                          <div class="ml-1">
                            <p class="m-0">
                              <strong>
                                {{ evolution.resident_name }}
                              </strong>
                            </p>
                            <p class="m-0">
                              <span class="text-muted"
                                >Data de nascimento:
                              </span>
                              {{
                                formatDate(
                                  evolution.resident_date_of_birth,
                                  false
                                )
                              }}
                              -
                              {{ getAge(evolution.resident_date_of_birth) }}
                              anos
                            </p>
                            <p class="m-0">
                              <span class="text-muted">Data de admissão: </span>
                              {{
                                formatDate(
                                  evolution.resident_date_of_reception,
                                  false
                                )
                              }}
                            </p>
                            <p class="m-0" v-if="evolution.resident_bed_id">
                              <span class="text-muted">Leito: </span>
                              <span class="text-muted">Nº: </span>
                              {{ evolution.bed_number }}
                              ,
                              <span class="text-muted">Andar: </span>
                              {{ evolution.bed_walk }}
                              ,
                              <span class="text-muted">ALA/Setor: </span>
                              {{ evolution.bed_ward_or_sector }}
                              ,
                              <span class="text-muted">Quarto: </span>
                              {{ evolution.bed_bedroom }}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <img class="logo" :src="logo" />
                          <br />
                          <span>
                            Data:
                            {{ formatDate(evolution.created_at, false) }}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <p class="text-muted text-center m-0">
                    EVOLUÇÃO - {{ handleType(evolution.type) }}
                  </p>
                  <p class="text-center">
                    {{ evolution.text }}
                  </p>
                  <div class="text-center" v-if="!certificate">
                    (Assinatura eletrônica)
                    {{
                      professionalClassCouncilValue({
                        id: evolution.user_professional_class_council_id,
                        name: evolution.user_name,
                        profile: evolution.user_profile_name,
                        cpf: evolution.user_cpf,
                        office: evolution.user_office,
                        value: evolution.user_professional_class_council_value,
                      })
                    }}
                    <span v-if="evolution.certificate_name">
                      <hr />
                      Esta evolução foi assinada eletronicamente.
                    </span>
                    <span>
                      -
                      {{ formatDate(evolution.created_at) }}
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <v-btn
          v-if="!certificate"
          class="btn-print float-right mt-2"
          v-on:click="printOut"
          >Imprimir</v-btn
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import { getAge } from "../../../lib/getAgeByDate";

import { userData } from "../../../lib/functions";

import routes from "../../../routes";

export default {
  name: "PrintOutCare",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      id: "",
      errors: [],
      client: {},
      evolution: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: true,
      certificate: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getAge,
    formatDate,
    professionalClassCouncilValue,

    handleType(type) {
      let types = {
        MEDICO: "MÉDICA",
        PSICOLOGO: "PSICOLÓGICA",
        ENFERMEIRO: "ENFERMEIRO(A)",
        NUTRICIONISTA: "NUTRICIONAL",
        FISIOTERAPEUTA: "FISIOTERAPÊUTICA",
        FONOAUDIOLOGO: "FONOAUDIÓLOGO(A)",
        TERAPEUTA_OCUPACIONAL: "TERAPEUTA OCUPACIONAL",
        MUSICOTERAPIA: "MUSICOTERAPIA",
        ASSISTENTE_SOCIAL: "ASSISTENTE SOCIAL",
        EDUCADOR_FISICO: "EDUCADOR FÍSICO",
        EDUCADORES_E_PEDAGOGOS: "EDUCADORES E PEDAGOGOS",
        DENTISTA: "DENTISTA",
        default: "TIPO NÃO ENCONTRADO!",
      };

      return types[type] || types["default"];
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      const { certificate } = routes.history.current.query;

      this.id = id;

      let { rest_home_id, user, logo } = userData();

      this.rest_home_id = rest_home_id;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      if (certificate) {
        this.certificate = certificate;
      }

      await this.getClient();
      await this.get();
    },
    async getClient() {
      try {
        this.loading = true;

        const { rest_home_id: id } = this;

        var params = { id };

        const response = await api.get("/rest-home/path", {
          params,
        });

        const { error, errors, client } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.client = client;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = {
          id,
        };

        const response = await api.get("/rest-home/evolution/print", {
          params,
        });

        const { error, errors, evolution } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.evolution = evolution;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    printOut: () => window.print(),
  },
};
</script>

<style>
.print-evolution .logo {
  height: 50px;
  object-fit: contain;
}
.print-evolution .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.print-evolution .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}
.print-evolution li {
  list-style-type: none;
}
@media print {
  .print-evolution button {
    display: none;
  }
  .print-evolution li {
    list-style-type: none;
  }
  .print-evolution .finish_user {
    font-size: small !important;
  }
}
</style>